import Image from 'next/image';
import { OurStory } from '@/lib/aboutPage';
import Link from 'next/link';

const OurStorySection = () => {
  return (
    <section 
      id="our-story" 
      className="py-16 px-6 overflow-hidden bg-white"
      aria-labelledby="story-heading"
    >
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-12 lg:gap-16 items-center lg:items-start">

        {/* Left Content Side */}
        <div className="w-full lg:w-1/2">
          <header className="text-center lg:text-left">
            <div className="flex items-center justify-center lg:justify-start gap-2 text-[#4F7AC2] font-bold mb-4">
              <span aria-hidden="true" className="text-xl">»</span>
              <span className="uppercase tracking-widest text-xs">Our Journey</span>
            </div>

            <h2 
              id="story-heading"
              className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#001D4A] mb-8 leading-tight lg:max-w-lg"
            >
              {OurStory.title}
            </h2>
          </header>

          <div className="space-y-6 text-gray-600 text-sm sm:text-base leading-relaxed mb-8 max-w-2xl mx-auto lg:mx-0">
            <p>{OurStory.description1}</p>
            <p>{OurStory.description2}</p>
            <p>{OurStory.description3}</p>
          </div>
        </div>

        {/* Right Image Composition Side */}
        <div className="w-full lg:w-1/2 relative mt-12 lg:mt-0 min-h-[500px] sm:min-h-[600px] lg:min-h-[750px]" aria-hidden="true">
          
          {/* Main Large Image */}
          <div className="relative lg:absolute lg:right-0 lg:top-0 w-full lg:w-[88%] h-[400px] sm:h-[500px] lg:h-[700px] overflow-hidden rounded-sm z-10 shadow-2xl">
            <Image
              src={OurStory.image}
              alt="Our team collaborating on innovative digital solutions"
              fill
              className="object-cover"
              sizes="(max-width: 1024px) 100vw, 40vw"
              loading="lazy"
            />
          </div>

          {/* Blue Founder Card - Semantically a Quote */}
          <aside className="absolute -top-6 right-4 sm:right-10 lg:-right-5 lg:-top-8 bg-[#4F7AC2] p-6 z-30 max-w-[240px] sm:max-w-[300px] shadow-2xl text-white">
            <blockquote className="m-0">
              <p className="text-lg sm:text-2xl font-bold mb-4 leading-tight">
                &ldquo;{OurStory.CEOquote}&rdquo;
              </p>
              <footer>
                <p className="font-bold text-base sm:text-lg">Abhishek Mehta</p>
                <cite className="text-[10px] uppercase tracking-widest opacity-90 not-italic">CEO & Founder</cite>
              </footer>
            </blockquote>
          </aside>

          {/*
          <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 lg:left-1/4 lg:bottom-12 bg-[#001D4A] py-6 px-8 sm:px-12 z-30 text-center min-w-[280px] sm:min-w-[340px] shadow-2xl border-b-4 border-[#4F7AC2]">
            <div className="text-white font-bold uppercase tracking-[0.2em] text-[10px] sm:text-xs">
              {OurStory.description4}
            </div>
          </div> */}

        </div>
      </div>
    </section>
  );
};

export default OurStorySection;